import Page from '@/components/pages/news-article/news-article-page-controller';
import getStaticPaths from '@/components/pages/news-article/news-article-page-static-paths';
import getStaticProps from '@/components/pages/news-article/news-article-page-static-props';

export default Page;
export { getStaticPaths, getStaticProps };
